(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('environment-tr', {
            parent: 'entity',
            url: '/environment-tr?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment-tr/environment-trs.html',
                    controller: 'Environment_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('environment-tr-detail', {
            parent: 'environment-tr',
            url: '/environment-tr/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.environment_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment-tr/environment-tr-detail.html',
                    controller: 'Environment_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Environment_tr', function($stateParams, Environment_tr) {
                    return Environment_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'environment-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('environment-tr-detail.edit', {
            parent: 'environment-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-dialog.html',
                    controller: 'Environment_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment_tr', function(Environment_tr) {
                            return Environment_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment-tr.new', {
            parent: 'environment-tr',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-dialog.html',
                    controller: 'Environment_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('environment-tr', null, { reload: 'environment-tr' });
                }, function() {
                    $state.go('environment-tr');
                });
            }]
        })
        .state('environment-tr.edit', {
            parent: 'environment-tr',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-dialog.html',
                    controller: 'Environment_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment_tr', function(Environment_tr) {
                            return Environment_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment-tr', null, { reload: 'environment-tr' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment-tr.delete', {
            parent: 'environment-tr',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-tr/environment-tr-delete-dialog.html',
                    controller: 'Environment_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Environment_tr', function(Environment_tr) {
                            return Environment_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment-tr', null, { reload: 'environment-tr' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
